import { ICourse2 } from '@et/types/Courses'
import { PAYMENT_TYPES_THEME } from '@et/types/Enums'
// TODO: reg price link and sale price link so we only have to change one item
const slug = 'watercolor-lettering-in-procreate'
const title = 'Watercolor Lettering in Procreate'
const course: ICourse2 = {
  theme: PAYMENT_TYPES_THEME.LIGHT,
  title,
  slug,
  videoId: `odfer50rfa`,
  keywords: [
    'watercolor', 'procreate', 'lettering', 'hand lettering', 'procreate brushes', 'watercolor flowers', 'watercolor texture', 'ipad', 'procreate tutorial lettering', 'watercolor paper texture', 'tutorial', 'tutorials', 'how to', 'procreate watercolor brushes', 'procreate tutorial watercolor', 'in depth procreate tutorial', 'procreate lettering brushes', 'procreate tutorial lettering', 'lettering in procreate', 'procreate brush lettering', 'lettering brushes', 'how to add brushes to procreate', 'how to install procreate brushes', 'project based learning', 'learn', 'learning', 'course', 'online course', 'guide', 'class',
  ],
  price: '97',
  salePrice: '77',
  motionMail: '',
  paymentPlan:{
      perMonth: '0',
      price: '0',
      savings: '0',
  },
  onSale: false,
  tagline: 'Create beautiful, realistic watercolor lettering in Procreate',
  classDescriptor: 'Mimic the look of real watercolor lettering in Procreate',
  intro: {
    imgName: 'procreate301/tablet-intro.png',
    imgAlt: 'Welcome to 3d Lettering in Procreate',
    bullets: [
      {
        title: 'Beginner Friendly',
        desc:
          'Step-by-step narration with closeups on all the details, so you feel confident in the process from start to finish.',
      },
      {
        title: 'A Versatile Process',
        desc:
          'Since every lettering style is different, this process has been fine-tuned to fit any situation. You’ll be able to achieve a realistic watercolor effect when you apply it to any style - hand lettered or typed.',
      },
      {
        title: 'Blend Options',
        desc:
          'You may want an ombré, one color, smooth transitions blend with one of your pieces and a multi-colored blend with water pockets on another. This course serves up 5 different blend options, so you’ll have plenty to choose from when you begin your next lettering piece.',
      },
      {
        title: 'Florals + Foliage Integration',
        desc:
          'Take your watercolor lettering even further by integrating florals and foliage! A bonus florals foundations module is included, so even if you’ve never painted florals before, you’ll be able to follow along and complete every project in the class.',
      },
    ],
  },
  projects: {
    beginner: [
      {
        title: 'Project 1',
        backgroundColor: `#a1337e`,
        textColor: `#f4b3d2`,
        subheadColor: `#fdfdfb`,
        projectImg: `procreate301/project-1.jpg`,
        projectImgMobile: `procreate301/project-1.jpg`,
        type: '',
        desc:
          'In the first project of this course, you’ll learn how to create a watercolor ombré effect by creating smooth transitions from dark to light. We’ll use a font for this, add in some saturated edging and finish things off with some extra texture and splatter details.',
      },
      {
        title: 'Project 2',
        backgroundColor: `#e8d5d1`,
        textColor: `#7e6964`,
        subheadColor: `#e76d76`,
        projectImg: `procreate301/project-2.jpg`,
        projectImgMobile: `procreate301/project-2-mobile.jpg`,
        type: '',
        desc:
          'In Project #2, we alternate the colors of our letters, then blend them believably together using the included watercolor bleed brush. We finish it up by adding in the extra details that really bring it to life with reduced opacity downstrokes, saturated edging and paint splatter.',
      },
      {
        title: 'Project 3',
        backgroundColor: `#4a5a59`,
        textColor: `#f0f0f0`,
        subheadColor: `#afc996`,
        projectImg: `procreate301/project-3.jpg`,
        projectImgMobile: `procreate301/project-3-mobile.jpg`,
        type: '',
        desc:
          'Our third project marries a base color and saturated color ‘drops’, blended throughout. Final details of dark edging and paint splatter are added, and we even paint in some simple leaves to enhance the final look.',
      },
      {
        title: 'Project 4',
        type: '',
        projectImg: `procreate301/project-4.jpg`,
        projectImgMobile: `procreate301/project-4-mobile.jpg`,
        backgroundColor: `#6c8779`,
        textColor: `#f0f0f0`,
        subheadColor: `#f0f0f0`,
        desc:
          'Using everything learned in the previous projects, we blend two different colors together and create areas of low opacity, which I call water pockets. These are areas in the lettering, that if it were real watercolor, would have a water pool, creating lots of transparency in the color. This variation from high to low transparency in addition to the two colors blending together creates a really eye catching, realistic outcome.',
      },
      {
        title: 'Project 5',
        type: '',
        projectImg: `procreate301/project-5.jpg`,
        projectImgMobile: `procreate301/project-5-mobile.jpg`,
        backgroundColor: `#8dcdc3`,
        textColor: `#ffffff`,
        subheadColor: `#419187`,
        desc:
          'Taking the same methods used in the previous project, we introduce additional colors and decorative elements while still maintaining those beautiful water pockets. Everything is enhanced further with reduced opacity downstrokes and saturated edging.',
      },
    ],
    advanced: [
      {
        title: 'Project 6',
        type: '',
        projectImg: `procreate301/project-6.jpg`,
        projectImgMobile: `procreate301/project-6-mobile.jpg`,
        backgroundColor: `#f3f0eb`,
        textColor: `#566572`,
        subheadColor: `#be8d87`,
        desc:
          'In our first project integrating florals and foliage, we create a script initial surrounded and intertwined with florals. We spend time planning out our final layout, then layer everything properly and utilize layer masks for a beautifully blended watercolor outcome.',
      },
      {
        title: 'Project 7',
        type: '',
        projectImg: `procreate301/project-7.jpg`,
        projectImgMobile: `procreate301/project-7-mobile.jpg`,
        backgroundColor: `#566572`,
        textColor: `#f3f0eb`,
        subheadColor: `#be8d87`,
        desc:
          'Using florals and foliage differently within typography, we fill an entire letter in Project 7. We focus on variation and scale for a balanced composition of loose style florals and foliage.',
      },
      {
        title: 'Project 8',
        type: '',
        projectImg: `procreate301/project-8.jpg`,
        projectImgMobile: `procreate301/project-8-mobile.jpg`,
        backgroundColor: `#be7d69`,
        textColor: `#f5f5f4`,
        subheadColor: `#544143`,
        desc:
          'In the final project of the class, we create a fall themed letter, surrounded by watercolor leaves. We use a new watercolor illustration approach, by creating loose watercolor washes overlaid with sketches. We fill in remaining gaps so once the template letter is removed, the negative space naturally creates a letter, surrounded by watercolor doodles.',
      },
    ],
  },
  curriculum: [
    {
      title: 'Welcome',
      videos: [
        {
          title: 'Class Overview + Installing Bonuses',
          duration: '10:47',
        },
      ],
    },
    {
      title: 'Project 1: Fade',
      videos: [
        {
          title: 'Project File setup',
          duration: '3:14',
        },
        {
          title: 'Applying the Ombrè Effect',
          duration: '5:51',
        },
        {
          title: 'Final Watercolor Details',
          duration: '7:13',
        },
      ],
    },
    {
      title: 'Project 2: You Are Enough',
      videos: [
        {
          title: 'Project File setup',
          duration: '6:13',
        },
        {
          title: 'Applying Watercolor',
          duration: '5:48',
        },
        {
          title: 'Final Details',
          duration: '5:43',
        },
      ],
    },
    {
      title: 'Project 3: Bright',
      videos: [
        {
          title: 'Project File Setup',
          duration: '3:29',
        },
        {
          title: 'Blending + Details',
          duration: '4:39',
        },
        {
          title: 'Adding Leaves',
          duration: '4:34',
        },
      ],
    },
    {
      title: 'Project 4: Colorful',
      videos: [
        {
          title: 'Project File setup',
          duration: '1:52',
        },
        {
          title: 'Implementing Color Blocks + Blends',
          duration: '6:03',
        },
        {
          title: 'Final Details',
          duration: '2:55',
        },
      ],
    },
    {
      title: 'Project 5: Cotton Candy',
      videos: [
        {
          title: 'Project File setup',
          duration: '2:26',
        },
        {
          title: 'Color Blocks + Blends',
          duration: '5:11',
        },
        {
          title: 'Final Details',
          duration: '2:54',
        },
      ],
    },

    {
      title: 'Bonus: Floral Foundations',
      videos: [
        {
          title: 'Method 1: Painting Realistic Florals',
          duration: '15:18',
        },
        {
          title: 'Method 1: Painting Realistic Foliage',
          duration: '10:07',
        },
        {
          title: 'Method 2: Painting Loose Style Florals',
          duration: '12:24',
        },
        {
          title: 'Method 2: Painting Loose Style Foliage',
          duration: '6:10',
        },
      ],
    },
    {
      title: 'Project 6: Floral Script Initial',
      videos: [
        {
          title: 'Project File Setup',
          duration: '8:50',
        },
        {
          title: 'Painting the Mail Floral',
          duration: '8:38',
        },
        {
          title: 'Painting the Floral #2',
          duration: '4:10',
        },
        {
          title: 'Painting the Floral #3',
          duration: '3:33',
        },
        {
          title: 'Integrating Florals',
          duration: '11:40',
        },
        {
          title: 'Integrating Foliage + Final Details',
          duration: '7:38',
        },
      ],
    },
    {
      title: 'Project 7: Floral Filled Letter',
      videos: [
        {
          title: 'Project File Setup',
          duration: '3:41',
        },
        {
          title: 'Painting Florals + Foliage: Part 1',
          duration: '9:15',
        },
        {
          title: 'Painting Florals + Foliage: Part 2',
          duration: '4:10',
        },
      ],
    },
    {
      title: 'Project 8: Floral Outlined Letter',
      videos: [
        {
          title: 'Project File Setup',
          duration: '4:31',
        },
        {
          title: 'Applying Watercolor to Oak Leaves',
          duration: '2:59',
        },
        {
          title: 'Final Details',
          duration: '3:50',
        },
      ],
    },
    {
      title: 'Next Steps',
      videos: [
        {
          title: 'Thank You + Next Steps',
          duration: '1:03',
        },
      ],
    },
  ],
  bonuses: {
    headerImgName: `procreate301/bonus-title.png`,
    imgAlt: 'Watercolor lettering in Procreate Bonuses',
    gridType: 2,
    items: [
      {
        title: 'Procreate Watercolor Lettering Brush Pack',
        desc: 'The full brush pack with extended license rights (a $25 value!) is included so you can follow along exactly! These are 8 custom brushes specifically designed for watercolor lettering (that you can also use for painting watercolor florals + foliage!), yours for free with enrollment.',
        imgName: 'procreate301/bonuses-1.jpg',
        imgAlt: 'Procreate Watercolor Lettering Brush Pack',
      },
      {
        title: '4 Unique Watercolor Paper Textures',
        desc: 'To make your work as realistic as possible, we’ll be using a watercolor paper texture for each project. To customize it further, choose from 4 different textures (deep tooth, medium-deep tooth, medium tooth and fine tooth), so you can create your project exactly the way you’d like. These are all high res, 300dpi and screen sized at 2732 x 2048px.',
        imgName: 'procreate301/bonuses-2.jpg',
        imgAlt: '4 Unique Watercolor Paper Textures',
      },
      {
        title: 'Each Project’s Color Swatches',
        desc: 'Install each color palette for every project so you can start working asap! These are the exact palettes seen, and since you can install them directly, you won’t waste any time inputting individual color builds.',
        imgName: 'procreate301/bonuses-3.jpg',
        imgAlt: 'Color Swatches Files',
      },
      {
        title: 'Every Project’s Procreate File',
        desc: 'If you ever get stuck or would like to reference the full file for any project, they’re all available to you as free downloads.',
        imgName: 'procreate301/bonuses-4.jpg',
        imgAlt: '8 Procreate Project Files',
      },
    ],
  },
  courseCard: {

    title: 'Lettering in Procreate',
    backgroundImgName: ``,
    backgroundColor: '#65807c',
    cardImgName: `procreate301/watercolor-class-card-4.jpg`,
    desc: 'Create beautiful and realistic watercolor lettering in Procreate! Learn versatile blending options, several texturing options and final details to bring your digital watercolor artwork to life. Created with beginners in mind, every step is described in detail, with clear control close ups and repetition for easy learning. This project based course makes learning fun with 8 unique projects to up your social media game at the same time. Get a bonus dose of inspiration and artwork options with florals and foliage foundations, so you’ll be able to create the stunning digital watercolor lettering compositions you’ve always wanted.',
    bullets: [
      'Access to 33 HD step-by-step videos',
      'Every project’s color palette',
      '8 unique watercolor lettering projects',
      'Bonus Florals + Foliage Foundations module',
      'Complete Procreate Watercolor Lettering Brush Pack (8 custom brushes)',
      'Extended license of the Procreate Watercolor Lettering Brush Pack',
      '4 unique watercolor paper textures',
      'Every project’s fully layered original Procreate file',
      'Unlimited updates',
      'Lifetime access to the class',
    ],
    brush: {
      enabled: true,
      image: {
        pencil: `apple2-pencil.png`,
        shadow: `sell-card-pencil-reflection-light.png`,
      },
    },
    priceColor: `#f3a792`,
    saleColor: `#f3a792`,
    stats: {
      modules: `#cc836f`,
      videos: `#758384`,
      hours: `#a79e8d`,
    },
  },
  faqs: [
    {
      question: 'Do you offer any refunds or guarantees?',
      answer: 'Sure do! If you finish the course, implement the techniques and feel you haven’t learned anything new, you can email me within 14 days of purchase for a full refund.',
    },
    {
      question: 'How long can I access the course for?',
      answer: 'Forever! As long as Every-Tuesday exists, this course will be available to watch. Take it at whatever pace you’d like, watch whenever, wherever and as many times as you’d like.',
    },
    {
      question: 'Is this a live or pre-recorded course?',
      answer: 'This course is entirely pre-recorded, so you can take it whenever it works best with your schedule.',
    },
    {
      question: 'Will I be able to access all the videos and bonuses at once?',
      answer: 'Yup!',
    },
    {
      question: 'What will I need to take this class?',
      answer: 'You’ll need an Apple Pencil and an iPad that is compatible with the Apple Pencil and provides pressure sensitivity (in the videos, I’m using a second generation Apple Pencil and a third generation iPad Pro, 12.9”, 256GB). You will also need the Procreate App (version 4.3 or newer) installed on your iPad to follow along and complete the course.',
    },
    {
      question: 'Do I need any special Procreate brushes to create these projects?  ',
      answer: 'Yes, and they’re all included for free with your enrollment in the bonuses section of the course (a video walkthrough of their location and install instructions is included in the very first video of the course).',
    },
    {
      question: 'I noticed there’s a similar course offered on Skillshare. What’s the difference?',
      answer: 'The course on Skillshare is an intro course that only includes the first 3 projects of this class. For a full comparison, please view this chart: https://every-tuesday.com/watercolor-lettering-comparison-chart',
    },
    {
      question: 'I’m still learning hand lettering. Is this for me?',
      answer: 'Yep! You’ll be able to apply all of the techniques from this course to fonts within Procreate, so there’s no pressure to use your own lettering if you’d prefer to wait.',
    },
  ],
  testimonials: [],
  letsDoThis: {
    imgName: 'procreate301/lets-do-this-2.jpg',
    altTag: 'Enroll in Watercolor lettering for Procreate today!',
    text: 'Welcome to Watercolor Lettering in Procreate, your course for creating beautiful and realistic watercolor lettering on an iPad.',
  },
  sellCard: {
    priceColor: `#525f7f`,
    saleColor: '#6f8fcd',
    cardImg: 'procreate301/sell-card.jpg',
    saleLink: 'https://sso.teachable.com/secure/52521/checkout/1384936/watercolor-lettering-in-procreate',
    paymentPlanLink: '',
    link: 'https://sso.teachable.com/secure/52521/checkout/1384935/watercolor-lettering-in-procreate',
    customBtnBackgroundColor: '#a83c99',
    h2Color: `#525f7f`,
    hoverColor: {
      h2: `#fff`,
      text: '#a83c99',
      overlay: '#a83c99',
    },
    bullets: [
      'Instant access to all videos and bonuses',
      'Extended license + full Procreate Watercolor Lettering Brush Pack',
      '4 unique watercolor paper textures',
      'All original Procreate project files',
      'Color swatches for each project',
      'Bonus Florals + Foliage Foundations module',
      '14 day money back guarantee',
    ],
  },
}
export default course
